<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <i class="fa fa-bars"></i> {{$t('str.admin')}}
            <div style="display:inline-block;">
              <b-form @submit.prevent="getList()">
                <b-input-group>
                  <b-form-input id="keyword" type="text" name="keyword" :placeholder="$t('str.search')"
                    v-model="keyword" @keyup.enter="getList()"></b-form-input>
                  <b-input-group-append>
                    <buttons button-type="search" />&nbsp;
                    <buttons button-type="reset_filter" @click="resetFilter()" />
                  </b-input-group-append>
                </b-input-group>
              </b-form>
            </div>
            <div class="card-header-actions">
              <router-link to="/account/admin/manage/0" class="card-header-action btn-setting">
                <buttons button-type="add_new" />
              </router-link>
            </div>
          </div>
          <p :class="{'text-center': true, 'd-none': items.length}" class="">{{$t('str.no-data')}}</p>
          <b-table :class="{'d-none': !items.length}" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template slot="action" slot-scope="data">
              <router-link :to="'/account/admin/manage/'+data.item.id">
                <buttons button-type="edit" />
              </router-link>
              &nbsp;
              <buttons button-type="delete" @click="confirmDelete(data.item.id)" />
            </template>
          </b-table>
          <nav :class="{'d-none': !items.length}">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <confirm-modal :item="confirmDeleteId" @confirm="deleteAdmin" @cancel="cancelDelete"></confirm-modal>
  </div>
</template>

<script>
import axios from 'axios'

import Pagination from '@/views/component/Pagination'
import ConfirmModal from '@/views/component/ConfirmModal'
import Buttons from '@/views/component/Buttons'

export default {
  name: 'Admin',
  components: {
    'paging': Pagination,
    'confirm-modal': ConfirmModal,
    'buttons': Buttons
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'name', sortable: true },
        { key: 'email', sortable: true },
        { key: 'action' }
      ],
      keyword: '',
      currentPage: 1,
      totalPage: 0,
      confirmModal: false,
      confirmDeleteId: ''
    }
  },
  methods: {
    async getList(page) {
      this.$auth.checkSession()
      var trail = `?limit=${this.$helper.envi.VUE_APP_PAGING_LIMIT}`
      if (page) trail = `${trail}&page=${page}`
      if (this.keyword != '') trail = `${trail}&keyword=${this.keyword}`

      try {
        var getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Admin${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.items = getData.data.data
        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount
      } catch (e) {
        console.log(e.response)
      }
    },
    async deleteAdmin(id) {
      this.$auth.checkSession()
      try {
        var result = await axios.delete(`${this.$helper.envi.VUE_APP_API_URL}/Admin/${id}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getList()
        this.confirmModal = false
      } catch (e) {
        console.log(e.response)
      }
    },
    resetFilter() {
      this.keyword = ''
      this.getList()
    },
    pageOneChanged(pageNum) {
      this.$auth.checkSession()
      this.currentPage = pageNum
      this.getList(pageNum)
    },
    confirmDelete(id) {
      this.$auth.checkSession()
      this.confirmModal = true
      this.confirmDeleteId = id
    },
    cancelDelete() {
      this.$auth.checkSession()
      this.confirmModal = false
    }
  },
  created() {
    this.getList()
  }
}
</script>